import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../../../Layout/Sidebar";
import Topbar from "../../../Layout/Topbar";
import { ToastContainer, toast } from "react-toastify";
import { Breadcrumb } from "react-bootstrap";
import * as Yup from "yup";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./TimeLogEntry.css";
import "react-time-picker/dist/TimePicker.css";
import { encryptData } from "../../../Common/encryptionUtils";
import { apiRequest } from "../../../../services/api";
import { useNavigate } from "react-router-dom";
import Loader from "../../../Common/Loader";
import {
  Form,
  Button,
  Card,
  Dropdown,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import { Formik, Field, ErrorMessage } from "formik";
import {
  MenuItem,
  Select,
  Box,
  Typography,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Grid,
  TableHead,
  Chip,
} from "@mui/material";
import DropAndDropImage from "../../../../assets/draganddrop.png";
import RightArrrowImage from "../../../../assets/rightArrow.jpg";
import moment from "moment";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

// import 'react-clock/dist/Clock.css';

const StepProgress = ({ currentStep }) => {
  const steps = ["Mapped User Info", "Time Activity Data"];

  return (
    <div className="mb-4 position-relative">
      {/* Steps */}
      <div className="d-flex justify-content-between stepBarDiv position-relative w-100">
        {steps.map((step, index) => (
          <div
            key={`step-${index}`}
            className="text-center stepBar"
            style={{ flex: 1, position: "relative" }}
          >
            <div
              className={`step-circle ${
                index <= currentStep ? "completed" : ""
              }`}
              style={{
                width: "30px", // Circle size
                height: "30px", // Circle size
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "0 auto", // Center the circle
                border: "2px solid",
                borderColor: index <= currentStep ? "#007bff" : "#dcdcdc",
                backgroundColor:
                  index <= currentStep ? "#007bff" : "transparent",
                color: index <= currentStep ? "#fff" : "#dcdcdc",
              }}
            >
              {index <= currentStep ? "✔" : ""}
            </div>
            <span
              className={`mt-2 d-block stepTitle ${
                index <= currentStep ? "text-primary" : "text-muted"
              }`}
              style={{ fontSize: "12px" }}
            >
              {step}
            </span>
          </div>
        ))}
      </div>

      {/* Progress Bar Segments */}
      <div
        className="stepBarLine"
        style={{
          position: "absolute",
          top: "13px", // Position the bars below the steps
          left: 0,
          right: 0,
        }}
      >
        <div className="d-flex justify-content-between align-items-center w-100 stepbarwidth">
          {steps.slice(0, -1).map((_, index) => (
            <div
              key={`bar-timeActivity-${index}`}
              className={`bar-timeActivity-${index}`}
              style={{
                flex: 1,
                height: "2px",
                backgroundColor: index < currentStep ? "#007bff" : "#dcdcdc",
                margin: "0 10px", // Space between bars
                borderRadius: "4px",
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

const UserStepOne = ({
  onNext,
  mappedUsers,
  setMappedUsers,
  connectedDetails,
  setConnectedDetails,
}) => {
  const location = useLocation();
  const { start_date, end_date, premise_id, filteredUsers } =
    location.state || {};
  const customerDetails = JSON.parse(localStorage.getItem("customerDetails"));
  const [selectedPremise, setSelectedPremise] = useState(
    JSON.parse(localStorage.getItem("selectedTopBarPremises"))
  );
  const authToken = localStorage.getItem("authToken");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const pageLoading = (data) => {
    setLoading(data);
  };
  console.log("filteredUsers---->", filteredUsers);
  const initialValues = {
    firstName: "",
  };

  const createValidationSchema = Yup.object({
    firstName: Yup.string().required("First Name is required"),
  });

  const getEmployess = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const policyResponse = await apiRequest(
        `web_api/admin/getEmployeesFromPayrollService?customer_account_id=${customerDetails?.customerAccountId?.toString()}`,
        "GET",
        null,
        headers
      );

      if (
        policyResponse?.data?.status_code === 200 &&
        policyResponse?.data?.data
      ) {
        const customer_details = policyResponse.data?.data;
        setOriginalUsers(customer_details);
        setOriginalUsers1(customer_details);
        setTimeout(() => {
          pageLoading(false);
        }, 200);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 200);
        console.error(
          "Error: Invalid status code",
          policyResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const getZohoEmployess = async () => {
    pageLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const policyResponse = await apiRequest(
        `web_api/admin/fetchZohoEmployees?customer_account_id=${customerDetails?.customerAccountId?.toString()}`,
        "GET",
        null,
        headers
      );

      if (
        policyResponse?.data?.status_code === 200 &&
        policyResponse?.data?.data
      ) {
        const customer_details = policyResponse.data?.data;
        setOriginalUsers(customer_details);
        setOriginalUsers1(customer_details);
        setTimeout(() => {
          pageLoading(false);
        }, 200);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 200);
        console.error(
          "Error: Invalid status code",
          policyResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const getGustoEmployess = async () => {
    pageLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const policyResponse = await apiRequest(
        `web_api/admin/fetchGustoEmployees?customer_account_id=${customerDetails?.customerAccountId?.toString()}`,
        "GET",
        null,
        headers
      );

      if (
        policyResponse?.data?.status_code === 200 &&
        policyResponse?.data?.data
      ) {
        const customer_details = policyResponse.data?.data;
        setOriginalUsers(customer_details);
        setOriginalUsers1(customer_details);
        setTimeout(() => {
          pageLoading(false);
        }, 200);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 200);
        console.error(
          "Error: Invalid status code",
          policyResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const fetchAlluser = async (premise_id) => {
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const userResponse = await apiRequest(
        `api/user/getstaffdetailsbypremise?premise_id=${encryptData(
          premise_id?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (
        userResponse?.data?.status_code === 200 &&
        userResponse?.data?.data?.staffdetails
      ) {
        const user_details = userResponse.data?.data?.staffdetails;
        setSelectedUsers(user_details);
        setSelectedUsers1(user_details);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 100);
        console.error(
          "Error: Invalid status code",
          userResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const fetchMappedUsers = async (premise_id) => {
    try {
      pageLoading(true);
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const userResponse = await apiRequest(
        `web_api/admin/fetchQuickbooksMappedEmployee?premise_id=${encryptData(
          premise_id?.toString()
        )}&customer_account_id=${encryptData(
          customerDetails?.customerAccountId?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (userResponse?.data?.status_code === 200 && userResponse?.data?.data) {
        const user_details = userResponse.data?.data;
        setAlreadyMappedUsers(user_details);
        setTimeout(() => {
          pageLoading(false);
        }, 100);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 100);
        console.error(
          "Error: Invalid status code",
          userResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const fetchZohoMappedUsers = async (premise_id) => {
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const userResponse = await apiRequest(
        `web_api/admin/fetchZohoMappedEmployee?premise_id=${encryptData(
          premise_id?.toString()
        )}&customer_account_id=${encryptData(
          customerDetails?.customerAccountId?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (userResponse?.data?.status_code === 200 && userResponse?.data?.data) {
        const user_details = userResponse.data?.data;
        setAlreadyMappedUsers(user_details);
        setTimeout(() => {
          pageLoading(false);
        }, 100);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 100);
        console.error(
          "Error: Invalid status code",
          userResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const fetchGustoMappedUsers = async (premise_id) => {
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const userResponse = await apiRequest(
        `web_api/admin/fetchGustoMappedEmployee?premise_id=${encryptData(
          premise_id?.toString()
        )}&customer_account_id=${encryptData(
          customerDetails?.customerAccountId?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (userResponse?.data?.status_code === 200 && userResponse?.data?.data) {
        const user_details = userResponse.data?.data;
        setAlreadyMappedUsers(user_details);
        setTimeout(() => {
          pageLoading(false);
        }, 100);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 100);
        console.error(
          "Error: Invalid status code",
          userResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const reorderSelectedUsers = (alreadyMappedUsers, selectedUsers) => {
    if (!alreadyMappedUsers || alreadyMappedUsers.length === 0) {
      return selectedUsers; // no reorder needed
    }
    console.log("ReOrder");
    // Create a lookup for quick access by user_id
    const selectedUserMap = new Map(selectedUsers.map((u) => [u.user_id, u]));

    // Reorder based on alreadyMappedUsers order
    const reordered = alreadyMappedUsers
      .map((mapped) => selectedUserMap.get(mapped.user_id)) // get from selectedUsers
      .filter((u) => u !== undefined); // remove if not found

    // Append unmapped users at the end (optional)
    const unmapped = selectedUsers.filter(
      (u) => !alreadyMappedUsers.some((mapped) => mapped.user_id === u.user_id)
    );

    return [...reordered, ...unmapped];
  };

  const reorderOriginalUsers = (alreadyMappedUsers, originalUsers) => {
    if (!alreadyMappedUsers || alreadyMappedUsers.length === 0) {
      return originalUsers; // no reorder needed
    }

    // Detect key based on platform
    const getOriginalKey = (u) => {
      switch (connectedDetails?.platform) {
        case "QuickBooks":
          return u.Id;
        case "Zoho":
          return u["Employee ID"]; // ✅ fixed: use "Employee ID"
        case "Gusto":
          return u.uuid; // ✅ use uuid (as per mergedUsers code)
        default:
          return u.uuid; // fallback
      }
    };

    const getMappedKey = (mapped) => {
      switch (connectedDetails?.platform) {
        case "QuickBooks":
          return mapped.qb_employee_id;
        case "Zoho":
          return mapped.zoho_employee_id;
        case "Gusto":
          return mapped.gusto_employee_id;
        default:
          return mapped.gusto_employee_id; // fallback
      }
    };

    // Create a lookup for quick access by user_id
    const selectedUserMap = new Map(
      originalUsers.map((u) => [getOriginalKey(u), u])
    );

    // Reorder based on alreadyMappedUsers order
    const reordered = alreadyMappedUsers
      .map((mapped) => selectedUserMap.get(getMappedKey(mapped)))
      .filter((u) => u !== undefined);

    // Append unmapped users at the end
    const unmapped = originalUsers.filter(
      (u) =>
        !alreadyMappedUsers.some(
          (mapped) => getMappedKey(mapped) === getOriginalKey(u)
        )
    );

    return [...reordered, ...unmapped];
  };

  const [open, setOpen] = useState(false);

  const [originalUsers, setOriginalUsers] = useState([]);
  const [originalUsers1, setOriginalUsers1] = useState([]);

  const [selectedUsers, setSelectedUsers] = useState([]);

  const [selectedUsers1, setSelectedUsers1] = useState([]);

  const [alreadyMappedUsers, setAlreadyMappedUsers] = useState([]);

  // Handle reordering
  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const { source, destination } = result;

    if (source.droppableId === destination.droppableId) {
      // Reorder in same table
      if (source.droppableId === "original") {
        const items = Array.from(originalUsers);
        const [reordered] = items.splice(source.index, 1);
        items.splice(destination.index, 0, reordered);
        setOriginalUsers(items);
      } else {
        const items = Array.from(selectedUsers);
        const [reordered] = items.splice(source.index, 1);
        items.splice(destination.index, 0, reordered);
        setSelectedUsers(items);
      }
    }

    setSubmitMessage("");
    setIsSuccess(null);
  };

  const [submitMessage, setSubmitMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(null);

  const handleSubmit = (values) => {
    // Build merged array (include all, even if unmatched)
    const mergedUsers = selectedUsers
      .slice(0, originalUsers.length) // ensure same count
      .map((selected, i) => {
        if (!selected || !originalUsers[i]) return null;

        const full_name = `${selected.first_name} ${selected.last_name}`;

        // 🔑 Handle platform-specific fields
        let original_full_name = "";
        let employee_id = "";

        if (connectedDetails?.platform === "QuickBooks") {
          original_full_name = originalUsers[i].Name;
          employee_id = originalUsers[i].Id;
        } else if (connectedDetails?.platform === "Zoho") {
          original_full_name = `${originalUsers[i]["First Name"]} ${originalUsers[i]["Last Name"]}`;
          employee_id = originalUsers[i]["Employee ID"];
        } else if (connectedDetails?.platform === "Gusto") {
          original_full_name = `${originalUsers[i].first_name} ${originalUsers[i].last_name}`;
          employee_id = originalUsers[i].uuid; // Gusto employees use uuid
        }

        const originalNameFirstWord = (original_full_name || "").split(" ")[0];
        const selectedNameFirstWord = full_name.split(" ")[0] || "";

        const isMatch = originalNameFirstWord === selectedNameFirstWord;

        // Return common structure with platform-specific IDs
        return {
          user_id: selected.user_id, // from selected
          staff_id: selected.staff_id, // from selected

          // ✅ Dynamic key assignment based on platform
          ...(connectedDetails?.platform === "QuickBooks" && {
            qb_employee_id: employee_id,
            qb_employee_name: original_full_name,
          }),
          ...(connectedDetails?.platform === "Zoho" && {
            zoho_employee_id: employee_id,
            zoho_employee_name: original_full_name,
          }),
          ...(connectedDetails?.platform === "Gusto" && {
            gusto_employee_id: employee_id,
            gusto_employee_name: original_full_name,
            gusto_job_id: originalUsers[i].jobs?.[0]?.uuid, // handle jobs array safely
            company_uuid: originalUsers[i].company_uuid,
          }),

          matched: isMatch, // extra flag (optional, useful for UI/debug)
        };
      })
      .filter(Boolean);

    // Check if all matched
    const allMatched = mergedUsers.every((u) => u.matched);

    if (allMatched) {
      setSubmitMessage("✅ All selected employees match the original order");
      setIsSuccess(true);
      setMappedUsers(mergedUsers);

      // 👉 Trigger respective API
      if (connectedDetails?.platform === "QuickBooks") {
        createQuickbooksEmployeeMapping(mergedUsers);
      } else if (connectedDetails?.platform === "Zoho") {
        createZohoEmployeeMapping(mergedUsers);
      } else if (connectedDetails?.platform === "Gusto") {
        createGustoEmployeeMapping(mergedUsers);
      }

      onNext(values);
    } else {
      console.log("originalUsersNotMatch--->", originalUsers);
      console.log("selectedUsersNotMatch--->", selectedUsers);
      console.log("mergedUsers (with matched/unmatched)--->", mergedUsers);
      setMappedUsers(mergedUsers);
      setConfirmDialogOpen(true);
      setIsSuccess(false);
    }

    // 👉 Console final flat array
    console.log("Final merged Users:", mergedUsers);
  };

  // const handleSubmit = (values) => {
  //   // Build merged array (include all, even if unmatched)
  //   const mergedUsers = selectedUsers
  //     .slice(0, originalUsers.length) // ensure same count
  //     .map((selected, i) => {
  //       if (!selected || !originalUsers[i]) return null;

  //       const full_name = `${selected.first_name} ${selected.last_name}`;
  //       const original_full_name =
  //         connectedDetails?.platform == "QuickBooks"
  //           ? originalUsers[i].Name
  //           : `${originalUsers[i]["First Name"]} ${originalUsers[i]["Last Name"]}`;
  //       const employee_id =
  //         connectedDetails?.platform == "QuickBooks"
  //           ? originalUsers[i].Id
  //           : originalUsers[i]["Employee ID"];
  //       const originalNameFirstWord = (originalUsers[i].Name || "").split(
  //         " "
  //       )[0];
  //       const selectedNameFirstWord = full_name.split(" ")[0] || "";

  //       const isMatch = originalNameFirstWord === selectedNameFirstWord;

  //       return {
  //         user_id: selected.user_id, // from selected
  //         staff_id: selected.staff_id, // from selected
  //         [connectedDetails?.platform === "QuickBooks"
  //           ? "qb_employee_id"
  //           : "zoho_employee_id"]: employee_id, // from original
  //         [connectedDetails?.platform === "QuickBooks"
  //           ? "qb_employee_name"
  //           : "zoho_employee_name"]: original_full_name, // from original
  //         matched: isMatch, // extra flag (optional, useful for UI/debug)
  //       };
  //     })
  //     .filter(Boolean);

  //   // Check if all matched
  //   const allMatched = mergedUsers.every((u) => u.matched);

  //   if (allMatched) {
  //     setSubmitMessage("✅ All selected employees match the original order");
  //     setIsSuccess(true);
  //     setMappedUsers(mergedUsers);
  //     connectedDetails?.platform === "QuickBooks"
  //       ? createQuickbooksEmployeeMapping(mergedUsers)
  //       : createZohoEmployeeMapping(mergedUsers);
  //     onNext(values);
  //   } else {
  //     console.log("originalUsersNotMatch--->", originalUsers);
  //     console.log("selectedUsersNotMatch--->", selectedUsers);
  //     console.log("mergedUsers (with matched/unmatched)--->", mergedUsers);
  //     setMappedUsers(mergedUsers);
  //     setConfirmDialogOpen(true);
  //     setIsSuccess(false);
  //   }

  //   // 👉 Console final flat array
  //   console.log("Final merged Users:", mergedUsers);
  // };

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const createQuickbooksEmployeeMappingData = async () => {
    setConfirmDialogOpen(false);
    if (connectedDetails?.platform === "QuickBooks") {
      await createQuickbooksEmployeeMapping(mappedUsers);
    } else if (connectedDetails?.platform === "Zoho") {
      await createZohoEmployeeMapping(mappedUsers);
    } else if (connectedDetails?.platform === "Gusto") {
      await createGustoEmployeeMapping(mappedUsers);
    }
    onNext();
  };

  const handleCancelUpload = () => {
    setConfirmDialogOpen(false);
  };

  const createQuickbooksEmployeeMapping = async (matchedUsers) => {
    // setConfirmDialogOpen(false);
    // Call your deactivation API here
    setLoading(true);
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        premise_id: selectedPremise?.value,
        customer_account_id: customerDetails?.customerAccountId,
        matchedUsers: matchedUsers,
      };
      const apiResponse = await apiRequest(
        "/web_api/admin/createQuickbooksEmployeeMapping",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        setOpen(false);
        setSubmitMessage("");
        // toast.success(apiResponse.data.message, {
        //   position: "top-right",
        //   autoClose: 4000,
        // });
      } else {
        toast.error("Invalid response from server");
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setLoading(false);
    }
  };

  const createZohoEmployeeMapping = async (matchedUsers) => {
    // setConfirmDialogOpen(false);
    // Call your deactivation API here
    setLoading(true);
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        premise_id: selectedPremise?.value,
        customer_account_id: customerDetails?.customerAccountId,
        matchedUsers: matchedUsers,
      };
      const apiResponse = await apiRequest(
        "/web_api/admin/createZohoEmployeeMapping",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        setOpen(false);
        setSubmitMessage("");
        // toast.success(apiResponse.data.message, {
        //   position: "top-right",
        //   autoClose: 4000,
        // });
      } else {
        toast.error("Invalid response from server");
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setLoading(false);
    }
  };

  const createGustoEmployeeMapping = async (matchedUsers) => {
    // setConfirmDialogOpen(false);
    // Call your deactivation API here
    setLoading(true);
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        premise_id: selectedPremise?.value,
        customer_account_id: customerDetails?.customerAccountId,
        matchedUsers: matchedUsers,
      };
      const apiResponse = await apiRequest(
        "/web_api/admin/createGustoEmployeeMapping",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        setOpen(false);
        setSubmitMessage("");
        // toast.success(apiResponse.data.message, {
        //   position: "top-right",
        //   autoClose: 4000,
        // });
      } else {
        toast.error("Invalid response from server");
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setLoading(false);
    }
  };

  const checkConnectedStatus = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const policyResponse = await apiRequest(
        `web_api/admin/payroll/status?customer_account_id=${customerDetails?.customerAccountId?.toString()}`,
        "GET",
        null,
        headers
      );

      if (
        policyResponse?.data?.status_code === 200 &&
        policyResponse?.data?.data
      ) {
        const customer_details = policyResponse.data?.data;
        setConnectedDetails(customer_details);
        // Call dependent APIs here, after state update

        if (customer_details.platform === "QuickBooks") {
          getEmployess();
          fetchMappedUsers(selectedPremise?.value);
        } else if (customer_details.platform === "Zoho") {
          getZohoEmployess();
          fetchZohoMappedUsers(selectedPremise?.value);
        } else if (customer_details.platform === "Gusto") {
          getGustoEmployess();
          fetchGustoMappedUsers(selectedPremise?.value);
        }
        fetchAlluser(selectedPremise?.value);
        setTimeout(() => {
          pageLoading(false);
        }, 200);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 200);
        console.error(
          "Error: Invalid status code",
          policyResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };
  useEffect(() => {
    checkConnectedStatus();
  }, []);

  useEffect(() => {
    if (alreadyMappedUsers?.length > 0) {
      console.log("user_detailsData--->", alreadyMappedUsers);
      console.log("selectedUsersFilter--->", selectedUsers);
      const filteredSelected = selectedUsers.filter(
        (u) => filteredUsers.some((f) => f.staff_id === u.staff_id) // staff_id ↔ staff_id mapping
      );
      console.log("filteredSelected--->", filteredSelected);
      const newOrder = reorderSelectedUsers(
        alreadyMappedUsers,
        filteredSelected
      );
      console.log("user_detailsData--->", alreadyMappedUsers);
      setSelectedUsers(newOrder);
    } else {
      const filteredSelected = selectedUsers.filter(
        (u) => filteredUsers.some((f) => f.staff_id === u.staff_id) // staff_id ↔ staff_id mapping
      );

      setSelectedUsers(filteredSelected);
    }
  }, [alreadyMappedUsers, selectedUsers1]);

  const reorderMappedByFiltered = (alreadyMappedUsers, filteredSelected) => {
    if (!filteredSelected || filteredSelected.length === 0)
      return alreadyMappedUsers;

    const userMap = new Map(alreadyMappedUsers.map((u) => [u.user_id, u]));

    const reordered = filteredSelected
      .map((fs) => userMap.get(fs.user_id))
      .filter(Boolean);

    const unmapped = alreadyMappedUsers.filter(
      (u) => !filteredSelected.some((fs) => fs.user_id === u.user_id)
    );

    return [...reordered, ...unmapped];
  };

  useEffect(() => {
    if (alreadyMappedUsers?.length > 0) {
      const filteredSelected = selectedUsers.filter(
        (u) => filteredUsers.some((f) => f.staff_id === u.staff_id) // staff_id ↔ staff_id mapping
      );
      if (filteredSelected?.length > 0) {
        const reorderedMapped = reorderMappedByFiltered(
          alreadyMappedUsers,
          filteredSelected
        );

        const newOriginalOrder = reorderOriginalUsers(
          reorderedMapped,
          originalUsers
        );
        setOriginalUsers(newOriginalOrder);
      } else {
        const newOriginalOrder = reorderOriginalUsers(
          alreadyMappedUsers,
          originalUsers
        );

        setOriginalUsers(newOriginalOrder);
      }
    } else {
    }
  }, [alreadyMappedUsers, originalUsers1]);

  const handleBackButton = () => {
    navigate("/report/timing");
  };

  const arrowLength = Math.min(selectedUsers?.length, originalUsers?.length);

  return (
    <Formik
      initialValues={initialValues}
      // validationSchema={
      //   location.pathname === "/user/create"
      //     ? createValidationSchema
      //     : updateValidationSchema
      // }
      //   validationSchema={createValidationSchema}
      onSubmit={(values) => {
        handleSubmit(values);
      }}
    >
      {({ handleSubmit, setFieldValue, values }) => (
        <Card
          className="p-4 premiseDetailsSubDiv PremiseActionFirstForm"
          style={{
            borderRadius: "10px",
            border: "none",
            boxShadow: "0 6px 20px rgba(0, 0, 0, 0.3)",
          }}
        >
          {loading && <Loader />}
          <Card.Body>
            <div className="row ">
              <div className="col-md-12 col-12 userInfoDiv">
                <Form
                  noValidate
                  onSubmit={handleSubmit}
                  className=""
                  autoComplete="OFF"
                  style={{ marginTop: "0px" }}
                >
                  {/* Top Action Buttons Row */}
                  <div
                    className="d-flex justify-content-end UserActionBtn"
                    style={{
                      marginBottom: "-20px",
                    }}
                  >
                    {/* Mapping Section */}
                    <Box sx={{ width: "100%", p: 2 }}>
                      <DialogContent
                        sx={{
                          overflowX: { xs: "auto", md: "hidden" }, // scroll only on mobile
                          overflowY: "auto",
                          maxHeight: { xs: "80vh", md: "70vh" },
                        }}
                      >
                        {/* Drag Drop Tables */}
                        <DragDropContext onDragEnd={handleOnDragEnd}>
                          <Grid
                            container
                            spacing={4}
                            justifyContent="center"
                            alignItems="flex-start"
                            sx={{
                              flexWrap: { xs: "nowrap", md: "wrap" }, // prevent wrapping on mobile
                              minWidth: { xs: "580px", md: "auto" }, // force width so scroll works
                              marginTop: "-10px",
                            }}
                          >
                            {/* Selected Users Table */}
                            <Grid
                              item
                              xs={12}
                              md={5}
                              sx={{
                                paddingLeft: "20px !important",
                                paddingTop: "0px !important",
                                flex: "0 0 auto", // prevent flex growing/shrinking
                              }}
                            >
                              <Typography
                                variant="h6"
                                gutterBottom
                                sx={{ fontSize: "16px", fontWeight: "600" }}
                              >
                                Employee Names in BusinessTime
                              </Typography>
                              <Droppable droppableId="selected">
                                {(provided) => (
                                  <TableContainer
                                    component={Paper}
                                    sx={{ boxShadow: 3, borderRadius: 2 }}
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                  >
                                    <Table stickyHeader>
                                      <TableBody>
                                        {selectedUsers.map((user, index) => (
                                          <Draggable
                                            key={`BU${user.user_id}`}
                                            draggableId={`BU${user.user_id}`}
                                            index={index}
                                          >
                                            {(provided, snapshot) => (
                                              <TableRow
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                sx={{
                                                  background:
                                                    snapshot.isDragging
                                                      ? "#e0f7fa"
                                                      : "white",
                                                  cursor: "grab",
                                                }}
                                              >
                                                <TableCell
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  {user?.first_name +
                                                    " " +
                                                    user?.last_name}
                                                  <span className="cursor-grab text-gray-400 ml-2">
                                                    <img
                                                      src={DropAndDropImage}
                                                      alt="drag"
                                                      width={20}
                                                      height={20}
                                                      className="w-4 h-4 inline-block"
                                                    />
                                                  </span>
                                                </TableCell>
                                              </TableRow>
                                            )}
                                          </Draggable>
                                        ))}
                                        {provided.placeholder}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                )}
                              </Droppable>
                            </Grid>

                            {/* Middle Arrows */}
                            <Grid
                              item
                              xs={12}
                              md={1}
                              sx={{
                                paddingLeft: "12px !important",
                                paddingTop: "0px !important",
                                flex: "0 0 auto",
                              }}
                            >
                              <Typography
                                variant="h6"
                                sx={{
                                  fontSize: "16px",
                                  fontWeight: "600",
                                  marginTop: "30px",
                                }}
                              ></Typography>
                              <TableContainer
                                component={Paper}
                                sx={{
                                  boxShadow: "none",
                                  border: "none",
                                  borderRadius: 0,
                                  overflowX: "hidden !important",
                                }}
                              >
                                <Table>
                                  <TableBody>
                                    {Array.from({ length: arrowLength }).map(
                                      (_, index) => (
                                        <TableRow
                                          key={index}
                                          sx={{ background: "white" }}
                                        >
                                          <TableCell
                                            className="mappedArrowTd"
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              borderBottom:
                                                "1px solid white !important",
                                            }}
                                          >
                                            <span
                                              className="cursor-grab text-gray-400 ml-2"
                                              style={{ marginLeft: "5px" }}
                                            >
                                              <img
                                                src={RightArrrowImage}
                                                alt="drag"
                                                width={20}
                                                height={20}
                                                className="w-4 h-4 inline-block"
                                              />
                                            </span>
                                          </TableCell>
                                        </TableRow>
                                      )
                                    )}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Grid>

                            {/* Original Users Table */}
                            <Grid
                              item
                              xs={12}
                              md={5}
                              sx={{
                                paddingLeft: "20px !important",
                                paddingTop: "0px !important",
                                flex: "0 0 auto",
                              }}
                            >
                              <Typography
                                variant="h6"
                                gutterBottom
                                sx={{ fontSize: "16px", fontWeight: "600" }}
                              >
                                Employee Names in{" "}
                                {connectedDetails?.platform || "Platform"}
                              </Typography>
                              <Droppable droppableId="original">
                                {(provided) => (
                                  <TableContainer
                                    component={Paper}
                                    sx={{ boxShadow: 3, borderRadius: 2 }}
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                  >
                                    <Table stickyHeader>
                                      <TableBody>
                                        {originalUsers &&
                                        originalUsers.length > 0 ? (
                                          originalUsers.map((user, index) => {
                                            // Compute employeeKey and employeeName based on platform
                                            let employeeKey;
                                            let employeeName;

                                            switch (
                                              connectedDetails?.platform
                                            ) {
                                              case "Gusto":
                                                employeeKey = user.uuid; // or user.Id if needed
                                                employeeName = `${user.first_name} ${user.last_name}`;
                                                break;
                                              case "QuickBooks":
                                                employeeKey = user.Id;
                                                employeeName = user?.Name;
                                                break;
                                              case "Zoho":
                                                employeeKey =
                                                  user["Employee ID"];
                                                employeeName = `${user["First Name"]} ${user["Last Name"]}`;
                                                break;
                                              default:
                                                employeeKey = user.Id;
                                                employeeName = `${user["First Name"]} ${user["Last Name"]}`;
                                            }

                                            return (
                                              <Draggable
                                                key={`OR${employeeKey}`}
                                                draggableId={`OR${employeeKey}`}
                                                index={index}
                                              >
                                                {(provided, snapshot) => (
                                                  <TableRow
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    sx={{
                                                      background:
                                                        snapshot.isDragging
                                                          ? "#e0f7fa"
                                                          : "white",
                                                      cursor: "grab",
                                                    }}
                                                  >
                                                    <TableCell
                                                      sx={{
                                                        display: "flex",
                                                        justifyContent:
                                                          "space-between",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      {employeeName}
                                                      <span className="cursor-grab text-gray-400 ml-2">
                                                        <img
                                                          src={DropAndDropImage}
                                                          alt="drag"
                                                          width={20}
                                                          height={20}
                                                          className="w-4 h-4 inline-block"
                                                        />
                                                      </span>
                                                    </TableCell>
                                                  </TableRow>
                                                )}
                                              </Draggable>
                                            );
                                          })
                                        ) : (
                                          <TableRow>
                                            <TableCell
                                              colSpan={2}
                                              sx={{
                                                textAlign: "center",
                                                color: "gray",
                                                py: 2,
                                              }}
                                            >
                                              Employee not found
                                            </TableCell>
                                          </TableRow>
                                        )}
                                        {provided.placeholder}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                )}
                              </Droppable>
                            </Grid>
                          </Grid>
                        </DragDropContext>
                      </DialogContent>

                      <Box
                        textAlign="center"
                        justifyContent="center"
                        mt={3}
                        className="NoteDivMapped"
                      >
                        {submitMessage && (
                          <p
                            style={{
                              color: isSuccess ? "green" : "red",
                              textAlign: "center",
                              marginTop: "-10px",
                              marginBottom: "-10px",
                            }}
                          >
                            {submitMessage}
                          </p>
                        )}
                      </Box>

                      {/* Action Buttons */}
                      <Box textAlign="end" mt={3}>
                        <Button
                          className="previousBtn"
                          variant="light"
                          onClick={handleBackButton}
                        >
                          Back
                        </Button>
                        <Button
                          className="previousBtn premiseNextBtn"
                          variant="primary"
                          onClick={handleSubmit}
                          style={{ marginLeft: "20px" }}
                          disabled={originalUsers.length === 0}
                        >
                          Next
                        </Button>
                        {/* <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          sx={{ mr: 2 }}
                          onClick={handleSubmit}
                        >
                          Submit
                        </Button>
                        <Button
                          variant="outlined"
                          onClick={() => {
                            setSubmitMessage("");
                            setSelectedUsers([]); // optional reset
                          }}
                        >
                          Cancel
                        </Button> */}
                      </Box>
                    </Box>

                    {/* Next Button */}
                    {/* <Button
                      className="previousBtn premiseNextBtn"
                      type="submit"
                      variant="primary"
                      style={{ marginLeft: "20px" }}
                    >
                      Next
                    </Button> */}
                  </div>
                </Form>
              </div>

              <Dialog open={confirmDialogOpen}>
                <DialogTitle
                  sx={{
                    backgroundColor: "#1976d2",
                    color: "#fff",
                    padding: "10px 24px",
                    fontSize: "1.1rem",
                  }}
                >
                  Confirm
                </DialogTitle>
                <DialogContent dividers>
                  <Typography variant="body2" color="textSecondary">
                    The employee order in BusinessTime does not match{" "}
                    {connectedDetails?.platform}. Do you want to continue?
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button
                    className="btn btn-info policyCancel"
                    onClick={() => handleCancelUpload()}
                    style={{
                      background: "white",
                      color: "#2c81d6",
                      border: "none",
                      fontSize: "13px",
                    }}
                  >
                    NO
                  </Button>
                  <Button
                    className="btn policyConfirmDeactive"
                    style={{
                      border: "none",
                      fontSize: "13px",
                      padding: "9px 18px",
                      borderRadius: "4px",
                      color: "white",
                    }}
                    onClick={() => {
                      createQuickbooksEmployeeMappingData();
                    }}
                  >
                    YES
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
          </Card.Body>
        </Card>
      )}
    </Formik>
  );
};

const UserStepTwo = ({
  onPrevious,
  onNext,
  timeZoneDetails,
  navigate,
  setPolicyList,
  policyList,
  mappedUsers,
  connectedDetails,
}) => {
  const location = useLocation();
  const { start_date, end_date, premise_id, selectedUsers } =
    location.state || {};
  const [loading, setLoading] = useState(false);
  console.log("selectedUsers:", selectedUsers);
  console.log("mappedUsers:", mappedUsers);
  const [showModal, setShowModal] = useState(false);
  const [timeEntryData, setTimeEntryData] = useState([]);
  const stepUserData =
    JSON.parse(localStorage.getItem("stepUserTwoData")) || {};

  const selectedTopBarPremises = JSON.parse(
    localStorage.getItem("selectedTopBarPremises")
  );
  // Initialize form fields with data from localStorage if available
  const initialValues = {
    accessLevel:
      JSON.parse(localStorage.getItem("stepUserTwoData"))?.accessLevel ||
      "staff", // Default to 'staff'
    operationalMode:
      JSON.parse(localStorage.getItem("stepUserTwoData"))?.operationalMode ||
      "manual-sensor", // Default to 'staff'
    passcode:
      JSON.parse(localStorage.getItem("stepUserTwoData"))?.passcode || "", // Default to 'staff'
    timeoff_feature:
      stepUserData?.timeoff_feature !== undefined
        ? stepUserData?.timeoff_feature
        : true,
    is_image_capture_enabled:
      stepUserData?.is_image_capture_enabled !== undefined
        ? stepUserData?.is_image_capture_enabled
        : true,
    auto_approve_or_reject:
      stepUserData?.auto_approve_or_reject !== undefined
        ? stepUserData?.auto_approve_or_reject
        : true,
    checkin_checkout_user_response_feature:
      stepUserData?.checkin_checkout_user_response_feature !== undefined
        ? stepUserData?.checkin_checkout_user_response_feature
        : true,
    staff_bt_enabled:
      stepUserData?.staff_bt_enabled !== undefined
        ? stepUserData?.staff_bt_enabled
        : true,
    user_status_enabled:
      stepUserData?.user_status_enabled !== undefined
        ? stepUserData?.user_status_enabled
        : true,
    leavePolicyId: stepUserData?.leavePolicyId,
    scheduler_feature:
      stepUserData?.scheduler_feature !== undefined
        ? stepUserData?.scheduler_feature
        : false,
    enforce_shift_time_checkin:
      stepUserData?.enforce_shift_time_checkin !== undefined
        ? stepUserData?.enforce_shift_time_checkin
        : false,
    checkin_grace_period_minutes:
      JSON.parse(localStorage.getItem("stepUserTwoData"))
        ?.checkin_grace_period_minutes || "10",
    force_checkout_after_shift_end_time:
      stepUserData?.force_checkout_after_shift_end_time !== undefined
        ? stepUserData?.force_checkout_after_shift_end_time
        : false,
    checkout_grace_period_minutes:
      JSON.parse(localStorage.getItem("stepUserTwoData"))
        ?.checkout_grace_period_minutes || "10",
    can_edit_shift:
      stepUserData?.can_edit_shift !== undefined
        ? stepUserData?.can_edit_shift
        : false,
  };

  const saveToLocalStorage = (key, value) => {
    // if (key === "is_customer_account_users") {
    //   setSuperUser(value);
    // }
    const currentData =
      JSON.parse(localStorage.getItem("stepUserTwoData")) || {};
    currentData[key] = value;
    localStorage.setItem("stepUserTwoData", JSON.stringify(currentData));
  };

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 575);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 575);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const customerDetails = JSON.parse(localStorage.getItem("customerDetails"));

  const stepUserTwoData = JSON.parse(
    localStorage.getItem("stepUserTwoData") || "{}"
  );
  const initialPasscode = stepUserTwoData.passcode || "";

  const [otp, setOtp] = useState(initialPasscode);

  const [passcodeError, setPasscodeError] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const inputRef = useRef();

  const handleChange = (e) => {
    const input = e.nativeEvent.data;
    const inputType = e.nativeEvent.inputType;

    let updatedOtp = otp;

    if (inputType === "deleteContentBackward") {
      updatedOtp = otp.slice(0, -1);
    } else if (input && /^\d$/.test(input)) {
      if (otp.length < 4) {
        updatedOtp = otp + input;
      }
    }

    setOtp(updatedOtp);
    saveToLocalStorage("passcode", updatedOtp);

    if (updatedOtp.length === 0 || updatedOtp.length === 4) {
      setPasscodeError("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Backspace") {
      handleChange(e);
    }
  };

  const handleToggleVisibility = () => {
    setShowOtp((prev) => !prev);
    inputRef.current?.focus();
  };

  // Header changes update all rows
  const handleHeaderChange = (userId, field, value) => {
    setTimeEntryData((prev) =>
      prev.map((user) => {
        if (user.user_id === userId) {
          const updatedUser = {
            ...user,
            [`header${capitalize(field)}`]: value, // value = {Id, Name}
            [field]: value,
          };

          updatedUser.users_date_time = updatedUser.users_date_time.map(
            (dayItem) => ({
              ...dayItem,
              timing_details: dayItem.timing_details.map((timing) => ({
                ...timing,
                [field]: value,
              })),
            })
          );

          return updatedUser;
        }
        return user;
      })
    );
  };

  const handleRowChange = (rowId, field, value) => {
    setTimeEntryData((prev) =>
      prev.map((user) => ({
        ...user,
        users_date_time: user.users_date_time.map((dayItem) => ({
          ...dayItem,
          timing_details: dayItem.timing_details.map((timing, idx) => {
            const id = `${user.user_id}-${dayItem.date}-${idx}`;
            if (id === rowId) return { ...timing, [field]: value }; // value = {Id, Name}
            return timing;
          }),
        })),
      }))
    );
  };

  const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

  console.log("setTimeEntryData--->", timeEntryData);

  const passcodeErrorRef = useRef(null);

  const [qbServices, setQBServices] = useState([]);

  const [qbCustomers, setQBCustomers] = useState([]);

  const fetchTimeEntryData = async (matchedUsers) => {
    // setConfirmDialogOpen(false);
    // Call your deactivation API here
    setLoading(true);
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      // const payload = {
      //   premise_id: "WTFVTTZXeHNHRVdTbVFrRWxQVXNwdz09",
      //   start_date: "cHdkSUNtS01nNVRsNHh6bi9wMHF6dz09",
      //   end_date: "b000NGJYdFhLVjlkYmFqc3NDbzdldz09",
      //   report_type: "JSON",
      // };

      const payload = {
        premise_id: premise_id,
        start_date: start_date,
        end_date: end_date,
        report_type: "JSON",
      };
      const apiResponse = await apiRequest(
        "api/user/getOverTimeDetails",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        console.log("apiResponse?.data--->", apiResponse?.data?.data);
        // const filteredTimeEntryData = apiResponse?.data?.data?.filter((entry) =>
        //   mappedUsers.some((user) => user.user_id === entry.user_id)
        // );

        const filteredTimeEntryData = mappedUsers
          .map((user) =>
            apiResponse?.data?.data?.find(
              (entry) => entry.user_id === user.user_id
            )
          )
          .filter(Boolean); // remove undefined if any user_id is not found

        setTimeEntryData(filteredTimeEntryData);
        // toast.success(apiResponse.data.message, {
        //   position: "top-right",
        //   autoClose: 4000,
        // });
      } else {
        toast.error("Fetch timing data error");
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTimeEntryData();
    if (connectedDetails?.platform == "QuickBooks") {
      getQBServices();
      getQBCustomers();
    }
  }, []);

  console.log("qbServices--->", qbServices);

  const [statuses, setStatuses] = useState({}); // rowId → Pending/success/Failed
  console.log("timeEntryData--->", timeEntryData);
  const handleSubmitDataTransferToQB = async () => {
    setShowModal(true);
    try {
      console.log("premise_idpremise_id--->", premise_id);
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        customer_account_id: encryptData(
          customerDetails?.customerAccountId?.toString()
        ),
        defaultService: qbServices[0],
        defaultCustomer: qbCustomers[0],
        premise_id: premise_id,
        data: timeEntryData,
      };

      const apiResponse = await apiRequest(
        "web_api/admin/timeActivitySubmitToQB",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.statuses) {
        const newStatuses = apiResponse.data.statuses;
        setStatuses((prev) => ({ ...prev, ...newStatuses }));

        // toast.success(apiResponse.data.message, {
        //   position: "top-right",
        //   autoClose: 4000,
        // });
      }
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setShowModal(false);
    }
  };

  const handleSubmitDataTransferToZoho = async () => {
    setShowModal(true);
    try {
      console.log("premise_idpremise_id--->", premise_id);
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        customer_account_id: encryptData(
          customerDetails?.customerAccountId?.toString()
        ),
        premise_id: premise_id,
        data: timeEntryData,
        date_value: selectedTopBarPremises?.date_format,
      };

      const apiResponse = await apiRequest(
        "web_api/admin/timeActivitySubmitToZoho",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.statuses) {
        const newStatuses = apiResponse.data.statuses;
        setStatuses((prev) => ({ ...prev, ...newStatuses }));

        // toast.success(apiResponse.data.message, {
        //   position: "top-right",
        //   autoClose: 4000,
        // });
      }
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setShowModal(false);
    }
  };

  const handleSubmitDataTransferToGusto = async () => {
    setShowModal(true);
    try {
      console.log("premise_idpremise_id--->", premise_id);
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        customer_account_id: encryptData(
          customerDetails?.customerAccountId?.toString()
        ),
        premise_id: premise_id,
        data: timeEntryData,
        date_value: selectedTopBarPremises?.date_format,
      };

      const apiResponse = await apiRequest(
        "web_api/admin/timeActivitySubmitToGustoTimeTracking",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.statuses) {
        const newStatuses = apiResponse.data.statuses;
        setStatuses((prev) => ({ ...prev, ...newStatuses }));

        // toast.success(apiResponse.data.message, {
        //   position: "top-right",
        //   autoClose: 4000,
        // });
      }
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setShowModal(false);
    }
  };

  const getQBServices = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const policyResponse = await apiRequest(
        `web_api/admin/fetchQBService?customer_account_id=${encryptData(
          customerDetails?.customerAccountId?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (
        policyResponse?.data?.status_code === 200 &&
        policyResponse?.data?.data
      ) {
        const customer_details = policyResponse.data?.data;
        setQBServices(customer_details);
      } else {
        console.error(
          "Error: Invalid status code",
          policyResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const getQBCustomers = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const policyResponse = await apiRequest(
        `web_api/admin/intuit/customers?customer_account_id=${encryptData(
          customerDetails?.customerAccountId?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (
        policyResponse?.data?.status_code === 200 &&
        policyResponse?.data?.data
      ) {
        const customer_details = policyResponse.data?.data;
        setQBCustomers(customer_details);
      } else {
        console.error(
          "Error: Invalid status code",
          policyResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  console.log("qbCustomers-->", qbCustomers);

  const [open, setOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  return (
    <>
      <Formik
        initialValues={initialValues}
        // validationSchema={
        //   location.pathname === "/user/create"
        //     ? superUser
        //       ? createValidationSchema
        //       : null
        //     : superUser
        //     ? updateValidationSchema
        //     : null
        // }
        onSubmit={(values) => {}}
      >
        {({ handleSubmit, setFieldValue, values }) => (
          <Card
            className="p-4 premiseDetailsSubDiv PremiseActionFirstForm"
            style={{
              borderRadius: "10px",
              border: "none",
              boxShadow: "0 6px 20px rgba(0, 0, 0, 0.3)",
            }}
          >
            {" "}
            {loading && <Loader />}
            <Card.Body>
              <div
                className="row usersecondBackBtnDiv"
                style={{ marginTop: "-20px" }}
              >
                <div className="col-6">
                  <i
                    className="fa fa-long-arrow-left backIcon"
                    aria-hidden="true"
                    style={{ cursor: "pointer" }}
                    onClick={onPrevious}
                  ></i>
                </div>
              </div>
              <div className="row userInformationDivConfig generalConfig UserGeneralSetting">
                <div
                  className="col-12 col-md-12"
                  style={
                    timeEntryData?.length === 0
                      ? {} // ❌ No scroll styles if no data
                      : { overflowX: "auto", maxHeight: "400px" } // ✅ Apply scroll only if data exists
                  }
                >
                  <Form
                    noValidate
                    onSubmit={handleSubmit}
                    className="premiseCreateForm userCreateFormConfig"
                    autoComplete="OFF"
                    style={{ marginTop: "-20px" }}
                  >
                    <div>
                      {timeEntryData?.length === 0 ? (
                        <Typography
                          sx={{ mt: 2, textAlign: "center", color: "gray" }}
                        >
                          No data found
                        </Typography>
                      ) : (
                        timeEntryData?.map((user) => (
                          <div
                            key={user.user_id}
                            style={{ marginBottom: "20px" }}
                          >
                            {/* User Name */}
                            <Typography
                              variant="h6"
                              fontWeight="bold"
                              sx={{ mb: 0.5 }}
                            >
                              {user.user_name}
                            </Typography>

                            {/* Date Range */}
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                              <b>From:</b>{" "}
                              {new Date(user.startDate).toLocaleDateString(
                                "en-US"
                              )}{" "}
                              , <b>To:</b>{" "}
                              {new Date(user.endDate).toLocaleDateString(
                                "en-US"
                              )}
                            </Typography>

                            <Paper
                              elevation={2}
                              sx={{
                                borderRadius: 2,
                                overflow: "hidden",
                                border: "1px solid #ddd",
                              }}
                            >
                              <TableContainer
                                sx={{
                                  maxHeight: 400,
                                  overflowX: "auto",
                                  position: "relative",
                                }}
                              >
                                <Table stickyHeader size="small">
                                  {/* Column Titles */}
                                  <TableHead>
                                    <TableRow
                                      sx={{
                                        backgroundColor: "#f5f5f5",
                                        top: 0,
                                        zIndex: 2,
                                      }}
                                    >
                                      <TableCell
                                        sx={{ p: 0.5, textAlign: "center" }}
                                      >
                                        <b>Date</b>
                                      </TableCell>
                                      <TableCell
                                        sx={{ p: 0.5, textAlign: "center" }}
                                      >
                                        <b>Day</b>
                                      </TableCell>
                                      <TableCell
                                        sx={{ p: 0.5, textAlign: "center" }}
                                      >
                                        <b>
                                          Time <br />
                                          IN
                                        </b>
                                      </TableCell>
                                      <TableCell
                                        sx={{ p: 0.5, textAlign: "center" }}
                                      >
                                        <b>
                                          Time <br />
                                          OUT
                                        </b>
                                      </TableCell>
                                      <TableCell
                                        sx={{ p: 0.5, textAlign: "center" }}
                                      >
                                        <b>
                                          Total <br />
                                          Hours
                                        </b>
                                      </TableCell>
                                      {connectedDetails?.platform ==
                                        "QuickBooks" && (
                                        <>
                                          <TableCell
                                            sx={{
                                              p: 0.5,
                                              minWidth: 120,
                                              textAlign: "center",
                                            }}
                                          >
                                            <b>Services</b>
                                            <select
                                              value={user.workType?.Id || ""}
                                              onChange={(e) => {
                                                const selected =
                                                  qbServices.find(
                                                    (s) =>
                                                      s.Id === e.target.value
                                                  );
                                                handleHeaderChange(
                                                  user.user_id,
                                                  "workType",
                                                  selected
                                                );
                                              }}
                                              style={{
                                                width: "100%",
                                                padding: "6px 8px",
                                                fontSize: "0.875rem",
                                                borderRadius: "6px",
                                                border: "1px solid #ccc",
                                                backgroundColor: "#fafafa",
                                                outline: "none",
                                                transition:
                                                  "all 0.2s ease-in-out",
                                              }}
                                              onFocus={(e) =>
                                                (e.target.style.borderColor =
                                                  "#4caf50")
                                              }
                                              onBlur={(e) =>
                                                (e.target.style.borderColor =
                                                  "#ccc")
                                              }
                                            >
                                              {qbServices.map((service) => (
                                                <option
                                                  key={service.Id}
                                                  value={service.Id}
                                                >
                                                  {service.Name}
                                                </option>
                                              ))}
                                            </select>
                                          </TableCell>

                                          <TableCell
                                            sx={{
                                              p: 0.5,
                                              minWidth: 120,
                                              textAlign: "center",
                                            }}
                                          >
                                            <b>Billable</b>
                                            <div
                                              style={{
                                                display: "flex",
                                                gap: "12px",
                                                alignItems: "center",
                                              }}
                                            >
                                              <label
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "4px",
                                                  cursor: "pointer",
                                                  fontSize: "0.875rem",
                                                }}
                                              >
                                                <input
                                                  type="radio"
                                                  name={`billable-header-${user.user_id}`}
                                                  value="Yes"
                                                  checked={
                                                    user.headerBillable ===
                                                    "Yes"
                                                  }
                                                  onChange={() =>
                                                    handleHeaderChange(
                                                      user.user_id,
                                                      "billable",
                                                      "Yes"
                                                    )
                                                  }
                                                  style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    accentColor: "#4caf50",
                                                    cursor: "pointer",
                                                    transition:
                                                      "all 0.2s ease-in-out",
                                                  }}
                                                />
                                                Yes
                                              </label>
                                              <label
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "4px",
                                                  cursor: "pointer",
                                                  fontSize: "0.875rem",
                                                }}
                                              >
                                                <input
                                                  type="radio"
                                                  name={`billable-header-${user.user_id}`}
                                                  value="No"
                                                  checked={
                                                    user.headerBillable ===
                                                      "No" ||
                                                    !user.headerBillable // Default to "No"
                                                  }
                                                  onChange={() =>
                                                    handleHeaderChange(
                                                      user.user_id,
                                                      "billable",
                                                      "No"
                                                    )
                                                  }
                                                  style={{
                                                    width: "16px",
                                                    height: "16px",
                                                    accentColor: "#f44336",
                                                    cursor: "pointer",
                                                    transition:
                                                      "all 0.2s ease-in-out",
                                                  }}
                                                />
                                                No
                                              </label>
                                            </div>
                                          </TableCell>
                                          {user.billable === "Yes" && (
                                            <TableCell
                                              sx={{
                                                p: 0.5,
                                                minWidth: 120,
                                                textAlign: "center",
                                              }}
                                            >
                                              <b>Customers</b>

                                              <select
                                                value={
                                                  user.billable_customer?.Id ||
                                                  ""
                                                }
                                                onChange={(e) => {
                                                  const selectedCustomer =
                                                    qbCustomers.find(
                                                      (c) =>
                                                        c.Id === e.target.value
                                                    );
                                                  handleHeaderChange(
                                                    user.user_id,
                                                    "billable_customer",
                                                    selectedCustomer
                                                  );
                                                }}
                                                style={{
                                                  width: "100%",
                                                  padding: "6px 8px",
                                                  fontSize: "0.875rem",
                                                  borderRadius: "6px",
                                                  border: "1px solid #ccc",
                                                  backgroundColor: "#fafafa",
                                                  outline: "none",
                                                  transition:
                                                    "all 0.2s ease-in-out",
                                                }}
                                                onFocus={(e) =>
                                                  (e.target.style.borderColor =
                                                    "#4caf50")
                                                }
                                                onBlur={(e) =>
                                                  (e.target.style.borderColor =
                                                    "#ccc")
                                                }
                                              >
                                                {qbCustomers.map((customer) => (
                                                  <option
                                                    key={customer.Id}
                                                    value={customer.Id}
                                                  >
                                                    {customer.DisplayName ||
                                                      customer.Name}
                                                  </option>
                                                ))}
                                              </select>
                                            </TableCell>
                                          )}
                                          <TableCell
                                            sx={{
                                              p: 0.5,
                                              minWidth: 120,
                                              textAlign: "center",
                                            }}
                                          >
                                            <b>Description</b>
                                            <input
                                              type="text"
                                              value={
                                                user.headerDescription ||
                                                `BusinessTime: ${user.user_name}`
                                              }
                                              onChange={(e) =>
                                                handleHeaderChange(
                                                  user.user_id,
                                                  "description",
                                                  e.target.value
                                                )
                                              }
                                              style={{
                                                width: "100%",
                                                padding: "2px 8px",
                                                fontSize: "0.875rem",
                                                borderRadius: "6px",
                                                border: "1px solid #ccc",
                                                backgroundColor: "#fff",
                                                outline: "none",
                                                transition:
                                                  "all 0.2s ease-in-out",
                                              }}
                                              onFocus={(e) =>
                                                (e.target.style.borderColor =
                                                  "#4caf50")
                                              }
                                              onBlur={(e) =>
                                                (e.target.style.borderColor =
                                                  "#ccc")
                                              }
                                            />
                                          </TableCell>
                                        </>
                                      )}
                                      <TableCell
                                        sx={{ p: 0.5, textAlign: "center" }}
                                      >
                                        <b>Status</b>
                                      </TableCell>
                                    </TableRow>

                                    {/* Header Inputs Row */}
                                  </TableHead>

                                  {/* Table Body */}
                                  <TableBody>
                                    {user.users_date_time.map((dayItem) => {
                                      const rowSpan =
                                        dayItem.timing_details.length;
                                      return dayItem.timing_details.map(
                                        (timing, idx) => {
                                          const rowId = `${user.user_id}-${dayItem.date}-${idx}`;
                                          return (
                                            <TableRow
                                              key={rowId}
                                              sx={{
                                                backgroundColor:
                                                  idx % 2 === 0
                                                    ? "#fff"
                                                    : "#f9f9f9",
                                                "&:hover": {
                                                  backgroundColor: "#e6f7ff",
                                                },
                                              }}
                                            >
                                              {idx === 0 && (
                                                <TableCell
                                                  rowSpan={rowSpan}
                                                  sx={{
                                                    p: 0.5,
                                                    minWidth: 100,
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  {moment(
                                                    dayItem.date,
                                                    "YYYY-MM-DD"
                                                  ).format("MM-DD-YYYY")}
                                                </TableCell>
                                              )}
                                              {idx === 0 && (
                                                <TableCell
                                                  rowSpan={rowSpan}
                                                  sx={{
                                                    p: 0.5,
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  {dayItem.day}
                                                </TableCell>
                                              )}

                                              <TableCell
                                                sx={{
                                                  p: 0.5,
                                                  textAlign: "center",
                                                }}
                                              >
                                                {timing["Time IN"]
                                                  ? timing["Time IN"].split(
                                                      " "
                                                    )[1]
                                                  : ""}
                                              </TableCell>
                                              <TableCell
                                                sx={{
                                                  p: 0.5,
                                                  textAlign: "center",
                                                }}
                                              >
                                                {timing["Time OUT"]
                                                  ? timing["Time OUT"].split(
                                                      " "
                                                    )[1]
                                                  : ""}
                                              </TableCell>

                                              <TableCell
                                                sx={{
                                                  p: 0.5,
                                                  textAlign: "right",
                                                  fontWeight: "600",
                                                }}
                                              >
                                                {timing.Total}
                                              </TableCell>
                                              {connectedDetails?.platform ==
                                                "QuickBooks" && (
                                                <>
                                                  {/* Work Type Select */}
                                                  <TableCell
                                                    sx={{
                                                      p: 0.5,
                                                      minWidth: 120,
                                                    }}
                                                  >
                                                    <select
                                                      value={
                                                        timing.workType?.Id ||
                                                        ""
                                                      }
                                                      onChange={(e) => {
                                                        const selectedService =
                                                          qbServices.find(
                                                            (s) =>
                                                              s.Id ===
                                                              e.target.value
                                                          );
                                                        handleRowChange(
                                                          rowId,
                                                          "workType",
                                                          selectedService
                                                        );
                                                      }}
                                                      style={{
                                                        width: "100%",
                                                        padding: "6px 8px",
                                                        fontSize: "0.875rem",
                                                        borderRadius: "6px",
                                                        border:
                                                          "1px solid #ccc",
                                                        backgroundColor:
                                                          "#fafafa",
                                                        outline: "none",
                                                        transition:
                                                          "all 0.2s ease-in-out",
                                                        cursor: "pointer",
                                                        // Scroll for dropdown options (browser native)
                                                        overflowY: "auto",
                                                      }}
                                                      onFocus={(e) =>
                                                        (e.target.style.borderColor =
                                                          "#4caf50")
                                                      }
                                                      onBlur={(e) =>
                                                        (e.target.style.borderColor =
                                                          "#ccc")
                                                      }
                                                    >
                                                      {qbServices.map(
                                                        (service) => (
                                                          <option
                                                            key={service.Id}
                                                            value={service.Id}
                                                            style={{
                                                              padding: "8px",
                                                              backgroundColor:
                                                                "#fff",
                                                              color: "#333",
                                                            }}
                                                          >
                                                            {service.Name}
                                                          </option>
                                                        )
                                                      )}
                                                    </select>
                                                  </TableCell>

                                                  {/* Billable Radio Buttons */}
                                                  <TableCell
                                                    sx={{
                                                      p: 0.5,
                                                      minWidth: 120,
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        gap: "12px",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <label
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          gap: "4px",
                                                          cursor: "pointer",
                                                          fontSize: "0.875rem",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          name={`billable-${rowId}`}
                                                          value="Yes"
                                                          checked={
                                                            (timing.billable ||
                                                              user.headerBillable) ===
                                                            "Yes"
                                                          }
                                                          onChange={() =>
                                                            handleRowChange(
                                                              rowId,
                                                              "billable",
                                                              "Yes"
                                                            )
                                                          }
                                                          style={{
                                                            width: "16px",
                                                            height: "16px",
                                                            accentColor:
                                                              "#4caf50",
                                                            cursor: "pointer",
                                                            transition:
                                                              "all 0.2s ease-in-out",
                                                          }}
                                                        />
                                                        Yes
                                                      </label>
                                                      <label
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          gap: "4px",
                                                          cursor: "pointer",
                                                          fontSize: "0.875rem",
                                                        }}
                                                      >
                                                        <input
                                                          type="radio"
                                                          name={`billable-${rowId}`}
                                                          value="No"
                                                          checked={
                                                            (timing.billable ||
                                                              user.headerBillable ||
                                                              "No") === "No"
                                                          }
                                                          onChange={() =>
                                                            handleRowChange(
                                                              rowId,
                                                              "billable",
                                                              "No"
                                                            )
                                                          }
                                                          style={{
                                                            width: "16px",
                                                            height: "16px",
                                                            accentColor:
                                                              "#f44336",
                                                            cursor: "pointer",
                                                            transition:
                                                              "all 0.2s ease-in-out",
                                                          }}
                                                        />
                                                        No
                                                      </label>
                                                    </div>
                                                  </TableCell>
                                                  {/* Customer Select - only if Billable */}
                                                  {timing.billable ===
                                                    "Yes" && (
                                                    <TableCell
                                                      sx={{
                                                        p: 0.5,
                                                        minWidth: 120,
                                                      }}
                                                    >
                                                      <select
                                                        value={
                                                          timing
                                                            .billable_customer
                                                            ?.Id || ""
                                                        }
                                                        onChange={(e) => {
                                                          const selectedCustomer =
                                                            qbCustomers.find(
                                                              (c) =>
                                                                c.Id ===
                                                                e.target.value
                                                            );
                                                          handleRowChange(
                                                            rowId,
                                                            "billable_customer",
                                                            selectedCustomer
                                                          );
                                                        }}
                                                        style={{
                                                          width: "100%",
                                                          padding: "6px 8px",
                                                          fontSize: "0.875rem",
                                                          borderRadius: "6px",
                                                          border:
                                                            "1px solid #ccc",
                                                          backgroundColor:
                                                            "#fafafa",
                                                          outline: "none",
                                                          transition:
                                                            "all 0.2s ease-in-out",
                                                          cursor: "pointer",
                                                          overflowY: "auto", // Scroll for dropdown options
                                                        }}
                                                        onFocus={(e) =>
                                                          (e.target.style.borderColor =
                                                            "#4caf50")
                                                        }
                                                        onBlur={(e) =>
                                                          (e.target.style.borderColor =
                                                            "#ccc")
                                                        }
                                                      >
                                                        {qbCustomers.map(
                                                          (customer) => (
                                                            <option
                                                              key={customer.Id}
                                                              value={
                                                                customer.Id
                                                              }
                                                              style={{
                                                                padding: "8px",
                                                                backgroundColor:
                                                                  "#fff",
                                                                color: "#333",
                                                              }}
                                                            >
                                                              {customer.DisplayName ||
                                                                customer.Name}
                                                            </option>
                                                          )
                                                        )}
                                                      </select>
                                                    </TableCell>
                                                  )}
                                                  {/* Description Input */}
                                                  <TableCell
                                                    sx={{
                                                      p: 0.5,
                                                      minWidth: 100,
                                                    }}
                                                  >
                                                    <input
                                                      type="text"
                                                      value={
                                                        timing.description ||
                                                        user.headerDescription ||
                                                        `BusinessTime: ${user.user_name}`
                                                      }
                                                      onChange={(e) =>
                                                        handleRowChange(
                                                          rowId,
                                                          "description",
                                                          e.target.value
                                                        )
                                                      }
                                                      style={{
                                                        width: "100%",
                                                        padding: "4px 8px",
                                                        fontSize: "0.875rem",
                                                        borderRadius: "6px",
                                                        border:
                                                          "1px solid #ccc",
                                                        backgroundColor: "#fff",
                                                        outline: "none",
                                                        transition:
                                                          "all 0.2s ease-in-out",
                                                      }}
                                                      onFocus={(e) =>
                                                        (e.target.style.borderColor =
                                                          "#4caf50")
                                                      }
                                                      onBlur={(e) =>
                                                        (e.target.style.borderColor =
                                                          "#ccc")
                                                      }
                                                    />
                                                  </TableCell>
                                                </>
                                              )}
                                              <TableCell
                                                sx={{
                                                  p: 0.5,
                                                  textAlign: "center",
                                                }}
                                              >
                                                <Chip
                                                  label={
                                                    statuses[rowId]?.status ||
                                                    "Pending"
                                                  }
                                                  color={
                                                    statuses[rowId]?.status ===
                                                    "Success"
                                                      ? "success"
                                                      : statuses[rowId]
                                                          ?.status === "Failed"
                                                      ? "error"
                                                      : statuses[rowId]
                                                          ?.status ===
                                                        "Already Uploaded"
                                                      ? "warning"
                                                      : "default"
                                                  }
                                                  onClick={() => {
                                                    if (
                                                      statuses[rowId]
                                                        ?.status === "Failed"
                                                    ) {
                                                      setErrorMsg(
                                                        statuses[rowId]
                                                          ?.message ||
                                                          "Unknown error"
                                                      );
                                                      setOpen(true);
                                                    }
                                                  }}
                                                  style={{
                                                    cursor:
                                                      statuses[rowId]
                                                        ?.status === "Failed"
                                                        ? "pointer"
                                                        : "default",
                                                  }}
                                                />
                                              </TableCell>
                                            </TableRow>
                                          );
                                        }
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Paper>
                            {/* <Dialog open={open} onClose={() => setOpen(false)}>
  <DialogTitle>Error Details</DialogTitle>
  <DialogContent>
    <p>{errorMsg}</p>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpen(false)} color="primary">
      Close
    </Button>
  </DialogActions>
</Dialog> */}

                            <Dialog open={open}>
                              <DialogTitle
                                sx={{
                                  backgroundColor: "#1976d2",
                                  color: "#fff",
                                  padding: "10px 24px",
                                  fontSize: "1.1rem",
                                }}
                              >
                                Error Details
                              </DialogTitle>
                              <DialogContent>
                                <p>{errorMsg}</p>
                              </DialogContent>
                              <DialogActions>
                                <Button
                                  onClick={() => setOpen(false)}
                                  color="primary"
                                >
                                  Close
                                </Button>
                              </DialogActions>
                            </Dialog>
                          </div>
                        ))
                      )}
                    </div>
                  </Form>
                </div>
                <div className="d-flex justify-content-end mt-4 mb-2">
                  <Button
                    className="previousBtn"
                    variant="light"
                    onClick={onPrevious}
                  >
                    Previous
                  </Button>
                  <Button
                    className="previousBtn premiseNextBtn"
                    type="submit"
                    onClick={() => {
                      if (connectedDetails?.platform === "QuickBooks") {
                        handleSubmitDataTransferToQB();
                      } else if (connectedDetails?.platform === "Zoho") {
                        handleSubmitDataTransferToZoho();
                      } else if (connectedDetails?.platform === "Gusto") {
                        handleSubmitDataTransferToGusto();
                      }
                    }}
                    disabled={timeEntryData?.length === 0}
                    variant="primary"
                  >
                    Upload
                  </Button>
                </div>
                <div
                  className={`modal ${showModal ? "fade show" : ""}`}
                  tabIndex="-1"
                  style={{ display: showModal ? "block" : "none" }}
                  aria-hidden={!showModal}
                >
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header bg-primary deleteMgeHeader text-white">
                        <h5 className="modal-title">Uploading Report</h5>
                        {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setShowModal(false)} disabled={isDownloading}></button> */}
                      </div>
                      <div className="modal-body text-center">
                        <p>Please wait, your report is uploading...</p>
                        <div className="dot-loader">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                      {/* <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => setShowModal(false)} disabled={isDownloading}>
                                      Close
                                    </button>
                                  </div> */}
                    </div>
                  </div>
                </div>
                {showModal && (
                  <div
                    className="modal-backdrop fade show"
                    // onClick={() => setShowModal(false)}
                  ></div>
                )}
              </div>
            </Card.Body>
          </Card>
        )}
      </Formik>
    </>
  );
};

const TimeLogEntry = () => {
  const location = useLocation();
  const userData = location.state?.user;
  const [currentStep, setCurrentStep] = useState(0);

  const handleNext = () => setCurrentStep((prev) => Math.min(prev + 1, 2));
  const handlePrevious = () => setCurrentStep((prev) => Math.max(prev - 1, 0));

  // const handleFileChange = (event) => {

  // };

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [selectedPremise, setSelectedPremise] = useState(
    JSON.parse(localStorage.getItem("selectedTopBarPremises"))
  );

  useEffect(() => {
    if (selectedPremise?.payroll_integration != "true") {
      navigate("/dashboard");
    }
  }, []);

  const handlePremiseSelect = (selected) => {
    if (selected?.value) {
      setSelectedPremise(selected);
      navigate("/users");
    }
  };

  const [policyList, setPolicyList] = useState([]);
  const [workShiftTemplates, setWorkShiftTemplates] = useState([]);
  const [mappedUsers, setMappedUsers] = useState([]);
  const [connectedDetails, setConnectedDetails] = useState(null);
  const authToken = localStorage.getItem("authToken");

  const selectedTopBarPremises = JSON.parse(
    localStorage.getItem("selectedTopBarPremises")
  );

  const customerDetails = JSON.parse(localStorage.getItem("customerDetails"));

  console.log("workShiftTemplates--->", workShiftTemplates);

  return (
    <div className="dashboard-layout">
      <Sidebar selectedPremise={selectedPremise} />
      <div className="main-content dashboardMain">
        <Topbar onPremiseSelect={handlePremiseSelect} />
        <ToastContainer />
        {loading && <Loader />}
        <div className="content">
          <div className="contentHeader d-flex align-items-center gap-3 pb-3">
            <div className="contentDiv">
              {/* <Breadcrumb className="contentTitle">
                <Breadcrumb.Item active>Users</Breadcrumb.Item>
                <Breadcrumb.Item active>
                  {userData?.user_phone_number ? "Update" : "Add"}
                </Breadcrumb.Item>
              </Breadcrumb> */}
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="card shadow premiseAddMainDiv QBListData">
                <Container>
                  <Row className="justify-content-center">
                    <Col>
                      {/* Step Progress and Bar at the top */}
                      <StepProgress currentStep={currentStep} />

                      {/* Form steps */}
                      {currentStep === 0 && (
                        <UserStepOne
                          onNext={handleNext}
                          mappedUsers={mappedUsers}
                          setMappedUsers={setMappedUsers}
                          connectedDetails={connectedDetails}
                          setConnectedDetails={setConnectedDetails}
                        />
                      )}
                      {currentStep === 1 && (
                        <UserStepTwo
                          onPrevious={handlePrevious}
                          onNext={handleNext}
                          setLoading={setLoading}
                          navigate={navigate}
                          mappedUsers={mappedUsers}
                          connectedDetails={connectedDetails}
                        />
                      )}
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeLogEntry;
